import ILSAnalyticsPlanningReportsComponent from '../components';

const ILSAnalyticsPlanningReportsContainer = () => {
  return <ILSAnalyticsPlanningReportsComponent />;
};

export default ILSAnalyticsPlanningReportsContainer;
